import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'

const LoadingIndicatorModal = ({ title }) => {
  useEffect(() => {
    return () => {
      const progressBar = document.getElementById('progressBar')
      if (progressBar && progressBar.MaterialProgress) {
        progressBar.MaterialProgress = null
      }
    }
  }, [])

  return ReactDOM.createPortal(
    <dialog open="open" className="mdl-dialog mdl-dialog--500" style={{ zIndex: 99 }}>
      <h4 className="mdl-dialog__title text--center">{title}</h4>
      <br />
      <br />
      <div style={{ position: 'relative' }}>
        <div className="progressBar__container">
          <div
            id="progressBar"
            className="mdl-progress mdl-js-progress mdl-progress__indeterminate block--full">
            <div className="progressbar bar bar1"></div>
            <div className="bufferbar bar bar2" style={{ width: '100%' }}></div>
            <div className="auxbar bar bar3" style={{ width: '0' }}></div>
          </div>
        </div>
      </div>
      <br />
    </dialog>,
    document.body
  )
}

export default LoadingIndicatorModal
